import { createContext } from 'react';

const UnitSocketContext = createContext({});

export default UnitSocketContext;
